import { Component, OnDestroy } from '@angular/core';

import { OnInit } from '@angular/core';
import { Chart }from 'chart.js';

import { DashboardService } from '../../services/dashboard.services';
import { GlobalCfgService } from '../../services/globalcfg.service';
import { EventBusService } from 'src/services/event-bus.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'rm-manufacturer-dashboard',
  templateUrl: './manufacturer-dashboard.component.html',
  styleUrls: ['./manufacturer-dashboard.component.css']
})
export class ManufacturerDashboardComponent implements OnInit, OnDestroy {

  gcp: any;
  role: any;
  user: any;
  userId: any;
  stats: any = {
    totalProducts: 0,
    totalLocations: 0,
    totalIncidents: 0,
    totalInvalidIncidents: 0
  };

  regionHeader = [['Country', 'Incidents']];
  regionEventResponse: any;
  regionEventData: any;

  top5Products: any[] = [];

  labels: any;

  roiData = {
    labels: [],
    labelCnt: [],
    validationCnt: [],
  };
  roiDataLn: any;

  eventTypesLn: any;

  subscriptions: any[] = [];

  constructor(
    private dashboardService: DashboardService,
    private route: ActivatedRoute,
    private globalCfgService: GlobalCfgService,
    private ebService: EventBusService
  ) { }

  ngOnInit() {
    this.gcp = this.globalCfgService.getGcp();
    this.labels = this.globalCfgService.getSettingValue('labels');
    this.user = this.globalCfgService.getFullUserObj();

    this.load();

    this.subscriptions.push(this.ebService.particpantSelectionFetchedValue$.subscribe(
      (gcp) => {
        this.gcp = gcp;
        this.load();
      }
    ));

    this.route.parent.url.subscribe(url => {
      //always the first part is role
      this.role = url.values().next().value.path;
      if (this.role == "distributor") {
        this.userId = this.user["dappUserId"];
      }
      // this.load();
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  load() {
    var obj = {};

    if (this.gcp) {
      obj['gcp'] = this.gcp;
    }

    if (this.role == "distributor") {
      obj['dappUserId'] = this.user["dappUserId"];
    }

    this.loadGeoMappedIncidents(obj);
    this.loadRoi();
    this.loadEventTypes();
    this.loadSummary();
    this.loadTopProducts();
  }

  loadSummary = function () {

    this.dashboardService.stats(this.gcp, this.userId).subscribe(
      (response) => {
        this.stats = Object(response);
      });
  }

  loadTopProducts = function () {

    this.dashboardService.topProducts(this.gcp, this.userId).subscribe(
      (response) => {
        this.top5Products = response;
      });
  }

  loadGeoMappedIncidents = function (obj) {

    this.dashboardService.regionWiseIncidents(obj).subscribe(
      (response) => {
        this.regionEventResponse = Object(response);

        this.regionEventResponse.forEach(item => {
          item.shift();
        })

        this.regionEventData = this.regionHeader.concat(this.regionEventResponse);

        window['google'].charts.load('current', {
          'packages': ['geochart'],
          // Note: you will need to get a mapsApiKey for your project.
          // See: https://developers.google.com/chart/interactive/docs/basic_load_libs#load-settings
          'mapsApiKey': 'AIzaSyD-9tSrke72PouQMnMX-a7eZSW0jkFMBWY'
        });
        window['google'].charts.setOnLoadCallback(drawRegionsMap);

        var thisObj = this;

        function drawRegionsMap() {


          // var data = window['google'].visualization.arrayToDataTable([
          //   ['Country', 'Incidents'],
          //   ['Germany', 200],
          //   ['United States', 600],
          //   ['Brazil', 400],
          //   ['Canada', 500],
          //   ['France', 600],
          //   ['Russia', 400],
          //   ['India', 800]
          // ]);

          // if (thisObj.regionEventData.length > 1) {
          var data = window['google'].visualization.arrayToDataTable(thisObj.regionEventData);

          var options = {
            colorAxis: { colors: ['#f5f5f5', '#1a55ae'] }
          };

          var chart = new window['google'].visualization.GeoChart(document.getElementById('regions_div'));

          chart.draw(data, options);
          // }
        }
      });
  }

  loadRoi = function () {

    this.dashboardService.roi(this.gcp).subscribe(
      (response) => {
        // this.stats =Object(response) ;
        // console.log("roi Data", response);

        this.roiData = response;
        this.roiDataLn = Object.keys(response).length;

        console.log("this.roiData", this.roiData);

        if (this.roiDataLn > 0) {
          var ctx2 = "monthwiseroi";
          var myChart = new Chart(ctx2, {
            type: 'bar',
            data: {
              labels: this.roiData.labels,
              datasets: [{
                label: "Generated",
                // backgroundColor: 'rgba(255, 99, 132, 1)',
                backgroundColor: 'rgba(26, 85, 174, 1)',
                data: this.roiData.labelCnt
              }, {
                label: "Validations",
                // backgroundColor: 'rgba(54, 162, 235, 1)',
                backgroundColor: 'rgba(158, 179, 194, 1)',
                data: this.roiData.validationCnt
              }]
            },
            options: {
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          });
        }
      });

  }

  loadEventTypes = function () {

    this.dashboardService.statByEventType(this.gcp, this.userId).subscribe(
      (response) => {


        var eventCnt = [];
        var eventType = [];

        var keys = Object.keys(response);
        this.eventTypesLn = keys.length;

        for (let index = 0; index < keys.length; index++) {
          const key = keys[index];
          eventType.push(key);
          eventCnt.push(response[key]);
        }

        console.log("eventCnt", eventCnt);
        console.log("eventType", eventType);

        if (eventType.length > 0) {
          console.log("position of Normar", eventType.indexOf("NORMAL"));

          var nrmIndex = eventType.indexOf("NORMAL");

          eventType = this.moveArrIndex(eventType, nrmIndex, 0);
          eventCnt = this.moveArrIndex(eventCnt, nrmIndex, 0);


          var ctx1 = 'eventtypes';
          var myPieChart = new Chart(ctx1, {
            type: 'doughnut',
            data: {
              datasets: [{
                // data: [6734, 165, 89, 65, 24, 45, 25, 478, 22, 5, 12, 256],
                data: eventCnt,
                backgroundColor: [
                  'rgba(13, 71, 161, 1)',
                  'rgba(21, 101, 192, 1)',
                  'rgba(25, 118, 210, 1)',
                  'rgba(30, 136, 229, 1)',
                  'rgba(33, 150, 243, 1)',
                  'rgba(66, 165, 245, 1)',
                  'rgba(100, 181, 246, 1)',
                  'rgba(144, 202, 249, 1)',
                  'rgba(187, 222, 251, 1)',
                  'rgba(200, 222, 281, 1)'
                ]

              }],
              labels: eventType
              //   [
              //     'Valid',
              //     'Fake',
              //     'Expired',
              //     'Overcooled',
              //     'Overheated',
              //     'High Moisture',
              //     'Low Moisture',
              //     'Recalled',
              //     'Geo-Fenced',
              //     'NSQ',
              //     'Banned',
              //     'Not For Sale'
              // ]
            },
            options: {
              legend: {
                position: 'right'
              }
            }
          });
        }
      });

  }

  moveArrIndex(arr, old_index, new_index) {
    while (old_index < 0) {
      old_index += arr.length;
    }
    while (new_index < 0) {
      new_index += arr.length;
    }
    if (new_index >= arr.length) {
      var k = new_index - arr.length;
      while ((k--) + 1) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  }
}